import { c as _c } from "react/compiler-runtime";
export const SectionSeparator = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative w-full py-8"><div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-0.5 bg-linear-to-r from-transparent via-white/60 to-transparent" /><div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-3/4 h-0.5 separator-glow" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};